import { render, staticRenderFns } from "./GenerateLabelButton.vue?vue&type=template&id=525f3811&scoped=true&"
import script from "./GenerateLabelButton.vue?vue&type=script&lang=js&"
export * from "./GenerateLabelButton.vue?vue&type=script&lang=js&"
import style0 from "./GenerateLabelButton.vue?vue&type=style&index=0&id=525f3811&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525f3811",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('525f3811')) {
      api.createRecord('525f3811', component.options)
    } else {
      api.reload('525f3811', component.options)
    }
    module.hot.accept("./GenerateLabelButton.vue?vue&type=template&id=525f3811&scoped=true&", function () {
      api.rerender('525f3811', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GenerateLabelButton.vue"
export default component.exports